module.exports = __webpack_public_path__ + "static/media/bolt-down.02ff58ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/bolt-down.png
// module id = 485
// module chunks = 0